<template>
    <div id="tcc_start"  v-responsive.class>
    
    <div  v-responsive.sm.xs class="cornerprefs">
        <Preferences
        :init_data="preferences"
        v-model="preferences"
        :update="save()"
        />
    </div>
    
    <div class="whitebg">
        <div class="center_content wide">
            <hr class="spacer">
                <Intro />
            <hr class="spacer">
        </div>   
    </div>     
            
    <div class="center_content first">
            
        <div id="main_content" class="padding">
            
            <div v-for="commute in commutes"
                :key="commute.name" :id="'commute_'+commute_number(commute)" >
                <div class="commute">
                    <h1 class="centered big sheen" v-if="commutes.length > 1" >
                    {{ $t('commute.title.number', {commute_number : commute_number(commute)}) }} 
                    </h1> 
                    
                    <Commute
                    :init_data="commute['data']"
                    :this_commute_number="commute_number(commute)"
                    :other_commutes="commutes"
                    v-model="commute['data']"
                    :update="save()"
                    />
                </div>
            </div>
            <div v-show="commute_1_complete" >
                <EnergyCosts :init_energy_costs=energy_costs :commutes=commutes v-model="energy_costs" :update="save()" />
            </div>
    
            <hr class="half spacer" />
            
            <div  v-if="commute_1_complete" class="centered row">
                    <div class="col centered">
                        <h3 v-scroll-to="'#totals'" >{{ $t('totals.scroll-to-total') }}  </h3>
                        <img v-scroll-to="'#totals'" src="icons/continue_30.png">
                    </div>
                    <div class="col"  v-responsive.lg.xl.md >
                        <br>
                        <button class="big green" v-if="commutes.length < 4" @click="addcommute()"><img src="icons/add_30_white.png"> {{ $t('commute.button.add') }} </button>
                    </div>
                </div>
                
        </div>
    
        <div id="right_sidebar"  v-responsive.lg.xl.md>
            <div id="navbar">
            
                <aside class="sidebar column is-3">
                    <affix class="menu sidebar-menu" relative-element-selector="#main_content" :offset="{ top: 30, bottom: 40 }" :scroll-affix="false">
                        <scrollactive active-class="active-item" class="menu-list" :offset="100">
                                <Preferences
                                    :init_data="preferences"
                                    v-model="preferences"
                                    :update="save()"
                                />
                
                                <a v-for="commute in commutes" v-if="commutes.length > 1" :href="'#commute_'+(commute_number(commute))"
                                class="scrollactive-item item">
                                    <span v-html="convert('vehicleIcon', commute)"></span> &nbsp;
                                    {{ $t('commute.title.number', {commute_number : commute_number(commute)}) }}
                                    <button class="red icon float_right" @click="deletecommute(commute)" v-tooltip="$t('delete-commute')">
                                    <img src="icons/trash_18_white.png" >
                                    </button>
                                </a>
                                
                                <a href="#totals" v-if="commutes.length > 1 && commute_1_complete " class="item scrollactive-item"  >
                                {{ $t('commute.title.total-sidebar') }}
                                <strong v-if="$data.total_annual_cost > 0"><br/><br/>
                                    {{ convert('formatMoney', $data._total_annual_cost, 0) }}
                                </strong>
                                </a>
                        </scrollactive>
                    </affix>
                </aside>
            </div>
        </div>
    </div>
    <div class="whitebg rombus-bottom" v-show="commute_1_complete">
        <div class="center_content wide">
            <div  id="totals">
                <hr class="spacer half" />
                <TotalsTable :commutes=commutes :energy_costs=energy_costs v-on:total_annual_cost="$data._total_annual_cost = $event" />
                
                <table style="width: 100%" >
                    <tr>
                        <td>
                            <h3 v-scroll-to="'#compare'" >{{ $t('totals.scroll-to-compare') }}  </h3>
                            <img v-scroll-to="'#compare'" src="icons/continue_30.png">
                        </td><td>
                            <StartOver v-on:start_over="reset_commutes()"/>
                        
                        </td>
                    </tr>
                </table>
                
                <hr class="spacer half" />
            </div>
        </div>

    </div>

    <div class="greybg wide rombus-top"  v-show="commute_1_complete" >
            <hr class="spacer" >

        <div class="main_content" id="compare">
        
            <div >
                <h3 v-if="commutes.length > 1">
                {{ $t('compare.bikeable-commutes' ) }}
                </h3>
        
                <div v-for="commute in commutes" v-if="commute_complete(commute)" >
                    <CompareCommute2Bike
                    :commute=commute :energy_costs=energy_costs
                    :commute_count=commutes.length
                    :init_data=commute.compare
                    v-model=commute.compare
                    :update="save()"
                    />
                </div>
                
                <div v-if="compare_bike_complete && compare_bike_possible" >
                    <CompareCommute2BikeBenefits />
               </div>
                <div  v-if="!compare_bike_possible" >
                    <CompareCommute2BikeFail :commutes=commutes />
                </div>
            
            </div>
        </div>
    </div>
    
    <div class="whitebg"  v-show="commute_1_complete" > 
        <div class="center_content wide">
        <hr class="half spacer" />
        <Feedback v-model="$data._feedback"
        :status="$data._feedback_status"
        v-on:submit="submit_feedback()"
        />
        </div>
    </div>
    

    <pre class="debug hide" @click=clear_local_data() >
        energy_costs: {{ energy_costs }}
        preferences: {{ preferences }}
        commutes: {{ commutes }}
    </pre>
    
    
</div>
</template>

<script>

import StartOver from './components/StartOver.vue'
import Preferences from './components/Preferences.vue'
import EnergyCosts from './components/EnergyCosts.vue'
import TotalsTable from './components/TotalsTable.vue'
import Commute from './components/Commute.vue'
import CompareCommute2Bike from './components/CompareCommute2Bike.vue'
import CompareCommute2BikeFail from './components/CompareCommute2BikeFail.vue'
import CompareCommute2BikeBenefits from './components/CompareCommute2BikeBenefits.vue'
import CompareCommuteSelector from './components/CompareCommuteSelector.vue'
import Feedback from './components/Feedback.vue'
import Intro from './components/Intro.vue'
import store from './localstorage.js'
import settings from './settings.js'
import debounce from "debounce";
import conversions from './conversions.js'

window['DEVMODE'] = (process.env.NODE_ENV == 'development')

window['REMOTE_API_URL'] = process.env.VUE_APP_REMOTE_API_URL
window['FRONT_VERSION'] = process.env.VUE_APP_VERSION
window['REMOTE_DATA_FREQUENCY'] = process.env.VUE_APP_REMOTE_DATA_FREQUENCY

export default {
    name: 'app',
    components : {
        Commute, Preferences, StartOver, TotalsTable,EnergyCosts, Intro, Feedback,
        CompareCommuteSelector, CompareCommute2Bike, CompareCommute2BikeFail, CompareCommute2BikeBenefits
    },
    created : function(){
        this.init()
    
        var vm = this

        window.addEventListener('blur', function() {
           // console.log('window.onblur');
            vm.send_remote_data('window.onblur')
        })
        
        window.addEventListener('beforeunload', function() {
            //console.log('window.onbeforeunload');
            vm.send_remote_data('window.onbeforeunload')
        })
        
        
    },
  
    data: function(){
        return {
            commutes : [{}],
            preferences : {},
            energy_costs : {},
            _total_annual_cost : 0,
            _remote_data_up_to_date: false,
            _feedback: {},
            _feedback_status: ""
        }
    },
    computed : {
        commute_1_complete : function(){
            try {
                if(this.commutes[0]['data']['complete']){
                    return true
                }
            } catch(err){}
            return false
        },
        compare_bike_possible : function(){
            for(let c in this.commutes){
                try {
                    if(this.commutes[c].compare._bikeable){
                        return true
                    }
                } catch(err){}
            }
           return false
        },
        compare_bike_complete : function(){
            for(let c in this.commutes){
                try {
                    if(this.commutes[c].compare.complete){
                        return true
                    }
                } catch(err){}
            }
           return false
        },
    },
    methods : {

        save : debounce(function(){
            let data = {}
            for (let k in this.$data){
                if(k[0] != "_"){
                    data[k] = JSON.stringify(this.$data[k])
                }
            }
            //console.log(data);
    
            let prevdata = store.getObj('tcc');
            
            if(JSON.stringify(prevdata) != JSON.stringify(data)){
                //console.log('tcc data has changed')
                store.setObj('tcc', data);

                this.$data._remote_data_up_to_date = false
                
                var vm = this

                debounce(function(){
                    vm.send_remote_data()
                }, REMOTE_DATA_FREQUENCY)
                
            } else {
                //console.log('tcc data has NOT changed')
            }
        }, 50),
        submit_feedback: function(){
            this.$data._feedback_status = "sending"
            this.save()
            this.$data._remote_data_up_to_date = false
            this.send_remote_data("feedback")
            var vm = this
            setTimeout(function(){
                vm.$data._feedback_status = "sent"
            }, 3000)
            
        },
        send_remote_data: function(trigger="data_update"){
            if(!this.$data._remote_data_up_to_date){
                //console.log('sending remote_data')
                let data = {}
                data['tcc'] = store.getObj('tcc');
                
                data['tcc'].commutes = this.anonymize_commutes(data['tcc'].commutes) 
                
                data['tcc_config'] = {}
                
                for (let i = 0; i < localStorage.length; i++){
                    if( localStorage.key(i).startsWith('tcc_config') ){
                        data['tcc_config'][localStorage.key(i)] = localStorage.getItem(localStorage.key(i))
                    }
                }

                data['feedback'] = this.$data._feedback;
                data['uuid'] = settings.getUUID();
                data['screen'] = {
                    'clientWidth' : document.body.clientWidth,
                    'clientHeight' : document.body.clientHeight,
                    'window.scrollY' : window.scrollY

                },
                data['trigger'] = trigger;
                data['front_url'] = location.href;
                data['front_version'] = FRONT_VERSION;
                
                var vm = this
                
                //console.log(data)
                //console.log(window['REMOTE_API_URL'])
                //console.log(process.env)
                
                this.$http.post(REMOTE_API_URL, JSON.stringify(data)
                ).then(function (response) {
                    // Success
                    vm.$data._remote_data_up_to_date = true
                    //console.log('sending remote_data success')
                    //console.log(response.data)
                },function (response) {
                    // Error
                    //console.log('sending remote_data fail')
                    //console.log(response.data)
                });
            }
        },
        anonymize_commutes: function(commutes){
            commutes = JSON.parse(commutes) 
            for(let c in commutes){
                try {
                    delete(commutes[c].data.commute_dist_time.traveltimes.key)
                    delete(commutes[c].data.commute_dist_time._mapcontainersrc)
                    for(let a in commutes[c].data.commute_dist_time.addresses){
                        for(let ac in commutes[c].data.commute_dist_time.addresses[a].address_components){
                            let keep = false
                            let keepers = ["postal_code", "country"]
                            for(let k in keepers){
                                if(commutes[c].data.commute_dist_time.addresses[a].address_components[ac].types.includes(keepers[k])){
                                    keep = true
                                }
                            }
                            if(!keep){
                                delete(commutes[c].data.commute_dist_time.addresses[a].address_components[ac])
                            }                
                        }
                        
                        delete(commutes[c].data.commute_dist_time.addresses[a].formatted_address)
                        commutes[c].data.commute_dist_time.addresses[a].latitude = parseFloat(commutes[c].data.commute_dist_time.addresses[a].latitude).toFixed(1)
                        commutes[c].data.commute_dist_time.addresses[a].longitude = parseFloat(commutes[c].data.commute_dist_time.addresses[a].longitude).toFixed(1)
                    }
                } catch(err){}
            }
            
            return JSON.stringify(commutes)
            
        },
        
        commute_number : function(commute){
            let i = 1
            for(let c in this.commutes){
                this.commutes[c]['number'] = i
                i++;
            }
            return commute.number
        },
        commute_complete : function(commute){
            try {
                if(commute.data.complete){
                    return true
                }
            } catch(err){}
            
            return false
        },
        clear_local_data : function(){
            store.clear();
            this.init();
        },
        reset_commutes : function(){
            this.commutes = [];
            this.$nextTick(function(){
                this.commutes.push({})
            });
        },
        deletecommute : function(commute){
            //console.log("deletecommute commute.number="+commute.number)
            //console.log(commute)
            for(let c in this.commutes){
                if(this.commutes[c].number === commute.number){
                    //console.log(this.commutes[c])
                    this.commutes.splice(c, 1)
                }
            }
        },
        addcommute : function(){
            this.commutes.push({})
            this.$nextTick(function(){
            this.$scrollTo('#commute_'+this.commutes.length, 300)
            });
        },
        convert: function(fn, ...args){
            return conversions[fn](...args);
        },
        init: function(){
            let init_data = store.getObj('tcc');
            for(let k in init_data){
                this.$data[k] = JSON.parse(init_data[k]);
            }
            
            if(this.commutes.length == 0){
                this.commutes.push({})
            }
        },
        
    }
  
}
</script>

<style>

ul li {
    list-style: none;
}

p {
    text-align: justify;
}


h1.big {
    text-shadow: 2px 1px #fff, 3px 3px #fff200;
    font-size: 34pt;
    color: #000;
 
}


.big.sheen {
   
    background: -moz-linear-gradient(left, rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.6) 33%, rgba(255,255,255,0.6) 66%,
    rgba(255,255,255,0) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.6) 33%,rgba(255,255,255,0.6) 66%,
rgba(255,255,255,0) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,0.6) 33%,rgba(255,255,255,0.6) 66%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

}

body {
    background-color: #ddd;
    color: #2f3640;
    padding: 0;
    margin: 0;
    font-family: 'Raleway', sans-serif;
}

h1, h2, h3, strong {
    font-family: 'Alfa Slab One', cursive;
    font-weight: normal;
}
    
.whitebg {
    background-color: #fff;
}

.greybg {
    background-color: #ececec;
}


.rombus-top {
    background-image: url(../public/icons/rombus_100.png);
    background-repeat: repeat-x;
    background-position: top -18px left;
}

.rombus-bottom {
    background-image: url(../public/icons/rombus_100.png);
    background-repeat: repeat-x;
    background-position: bottom -17px left;
}

.rombus {
    background-image: url(../public/icons/rombus_100.png);
    background-repeat: repeat-x;
    background-position: bottom left;
}

.center_content {
    sborder: 3px solid green;
    margin: auto;
    max-width: 900px;
    display: -webkit-flex;
    display: flex;
    text-align: center;

}

.center_content.first {
    height: auto;
    min-height: 100vh;
}


.wide {
    width: 100%;
    min-width: 500px;
    text-align: center;

}

.centered {
    text-align: center;
}

#main_content {
    background-color: #efefef;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: left;
    min-width: 320px;
    border-right: 2px solid #fff;
    border-left: 2px solid #fff;
}

#right_sidebar {
    sborder: 2px solid red;

    height: 100%;

    text-align: left;
    vertical-align: top;
    margin-left: 1px;
}



#navbar {
    width: 12em;

}

#navbar .item {
    background-color: #cecece
}

#navbar .item.active-item {
    background-color: #f6f6f6;
    border-right: 10px solid #f6f6f6;
    margin-right: -10px;
    border-radius: 0 9px 9px 0;
}


.active-item:hover {
    border-color: #333;
}

.item:visited:hover {
    color: #fff;
}

.item,.item:visited {
    color: inherit;
    width: 165px;
    text-decoration: none;

}

#navbar .active-item.item:hover {
    border-color: #333;
    background-color: #333;
    color: #fff;
}


.item:hover {
    background-color: #333;
    color: #fff;
}


#navbar .item {
    display: block;
    width: 165px;
    border-style: dotted;
    border-color: #fff;
    border-width: 1px 0 1px 0px;
    text-align: center;
    padding: 20px 12px 25px 5px;
    cursor: pointer;
}

button {
    border-radius: 5px;
    border: 1px solid #ccc;
    color: #eee;
    padding: .6em 1.5em;
}

button.orange {
    background-color: rgba(177, 121, 23, 1);
}
button.red {
    background-color: rgba(201, 53, 53, 1);
}

button.green {
    background-color: rgb(38, 139, 96);
}


button.grey {
    background-color: #666;
}


button:hover {
    background-color: #888;
    color: #fff;
    cursor: pointer;
}

button.icon {
    width: 2em;
    padding: .3em .1em;
    margin-top: -.4em;
}

button.big {
    border-radius: 18px;
    padding: 1em 2em;
    font-size: 12pt;
}


button > img {
    height: 1.2em;
    float: right;
    padding-left: 10px;
}

button.icon > img {
    padding: 0px;
    float: none;
}

h1 {
    smargin-top: 2em;
    spadding-top: 2em;
    sborder-top: 1px dotted #aaa;
}

h1, h2, h3 {
    clear: both;
}
p ::first-letter, span.capitalize, .capitalize ::first-letter, .capitalize * ::first-letter {
    text-transform:capitalize;
}

#left800 {
    width: 800px;
    display: none;
}


input {
    text-align: center
}
input.money {
    width: 5em;
    padding: .2em;
    font-family: monospace;
    height: 2em;
}


input.bigmoney {
    width: 7em;
    padding: .2em;
    font-family: monospace;
    height: 2em;
}

hr {
    border: 1px dotted #fff;
}

hr.break {
    clear: both;

}
hr.spacer {
    border: none;
    height: 6em;
    padding: 0;
    margin: 0;

}

hr.spacer.half {
    border: none;
    height: 3em;
    padding: 0;
    margin: 0;
}

.debug { 
    sdisplay: none
}

.float_right {
    float: right;
}

.float_left {
    float: left;
}

.nobr {
    white-space: nowrap;
}

.hide {
    display: none;
}


.bg {
    background-repeat: no-repeat;
    background-position: top right;
    min-height: 100px;
}

.bg.calendar {
    background-image: url("../public/icons/calendar_100_white_transparent.png");
}

.bg.calculator {
    background-image: url("../public/icons/calculator_100_white_transparent.png");
}

.bg.fuel {
    background-image: url("../public/icons/fuel_100_white_transparent.png");
}

.bg.charge {
    background-image: url("../public/icons/charge_100_white_transparent.png");
}




div.row {
    display: flex;
    flex-wrap: wrap;
}

div.row > div.col h3 {
    text-align: center;
}

div.row > div.col{
    flex-grow: 1;
    width: 20%;
    margin: 1em 3%;
    sborder: 1px solid red;
}








.tooltip {
  display: block !important;
  z-index: 500;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: .6em 1em;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}


div.table {
    display: table;
        cursor: default;
            border-width: 0 0 1px 1px ;
    border-style: dotted;
    border-color: #999999;
}


div.table div.tablerow {
    display: table-row;
}

div.table div.tablerow:hover {
    background-color: #fff;
} 

div.table div.cell, div.table .divTableHead {
    border-width: 1px 1px 0 0;
    border-style: dotted;
    border-color: #999999;
    display: table-cell;
    padding: 3px 10px;
}

div.table div.cell.green {
    background-color: rgb(38, 139, 96);
    color: #fff;

}

div.padding {
    padding: 1em;
}


div.table div.cell, div.table .divTableHead {
    text-align: right;
}

div.table.left div.cell, div.table.left .divTableHead {
    text-align: left;
}

div.table div.cell.centered {
    text-align: center;
}

div.table .divTableHeading {
    background-color: #EEE;
    display: table-header-group;
    font-weight: bold;
}
div.table div.body {
    display: table-row-group;
}

span.red {
    color: red;
    font-weight: bold;
}

input.red {
    color: red;
    background-color: #fdc5c5;    
}


/* responsive stuff  */

#tcc_start.bs4-sm, #tcc_start.bs4-xs {
    background-color: #ccc;
}


.bs4-sm * , .bs4-xs * {
    font-size: 10pt;

}

.bs4-sm * p, .bs4-xs * p {
    font-size: 10pt;
    margin: 1em .2em;
}

.bs4-sm h1,
.bs4-xs h1
 {
    font-size: 20pt;
}


bs4-sm h2, .bs4-sm h3,
.bs4-xs h2, .bs4-xs h3
 {
    font-size: 12pt;
}


.bs4-xs * input.money, .bs4-sm * input.money {
    width: 3em;
    padding: .1em;
    height: 1.5em;
}

.bs4-xs * input.bigmoney, .bs4-sm * input.bigmoney {
    width: 4em;
    padding: .1em;
    height: 1.5em;
}

.bs4-sm * div.table div.cell,
.bs4-xs * div.table div.cell{
    padding: 3px;
}


.bs4-sm * div.row > div.col,
.bs4-xs * div.row > div.col{
    width: 90%;
}

.bs4-xs *  .wide, .bs4-sm *  .wide {
    width: auto;
}

.cornerprefs {
    padding: 1em;
    background-color: #fff;
    cursor: pointer;
}


.cornerprefs div div strong{
    padding-left: 1em;
}

.bs4-sm .center_content,
.bs4-sm .wide,
.bs4-sm  #main_content,
.bs4-xs  .center_content,
.bs4-xs  .wide,
.bs4-xs  #main_content 
{

    min-width: 0;
    width: auto;
}


.bs4-xs div.padding,
.bs4-sm div.padding {
    padding: 0.6em;
}


.bs4-xs button.big,
.bs4-sm button.big{
    padding: 0.6em 0.8em;
    font-size: 10pt;
}


</style>
